"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateTime = exports.DateTimeField = void 0;
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var clsx_1 = __importDefault(require("clsx"));
var O = __importStar(require("fp-ts/Option"));
var function_1 = require("fp-ts/function");
var moment_timezone_1 = __importDefault(require("moment-timezone"));
var React = __importStar(require("react"));
var rxjs_1 = require("rxjs");
var operators_1 = require("rxjs/operators");
var FlexView_1 = require("../../../FlexView");
var Picker_1 = require("../../../Picker");
var nameFieldsBuilder_1 = require("../../nameFieldsBuilder");
var fieldMaker_1 = require("../fieldMaker");
var input_1 = require("../input");
var dateRawFormatter_1 = require("./dateRawFormatter");
require("./dateTime.css");
var DateTimeField = /** @class */ (function (_super) {
    __extends(DateTimeField, _super);
    function DateTimeField(props) {
        var _this = _super.call(this, props) || this;
        _this.onFocusChange$ = new rxjs_1.Subject();
        _this.subscription = null;
        _this.inputRef = {
            day: React.createRef(),
            month: React.createRef(),
            year: React.createRef(),
            hours: React.createRef(),
            mins: React.createRef(),
        };
        _this.pushUpDateTime = function (fieldName, length) { return function (value) {
            var fieldsUsed = _this.getFields().sort(_this.sortField);
            (0, function_1.pipe)(O.fromNullable(value), O.filter(function (v) { return v.toString().length === length; }), O.map(function (_) { return fieldsUsed.indexOf(fieldName); }), O.filter(function (i) { return i < fieldsUsed.length - 1; }), O.map(function (i) {
                return (0, function_1.pipe)(O.fromNullable(_this.inputRef[fieldsUsed[i + 1]].current), O.map(function (h) { return h.focus(); }));
            }));
            _this.onFocusChange$.next(true);
        }; };
        _this.allFieldIsFilled = function () {
            return _this.getFields().reduce(function (c, key) {
                var v = _this.inputRef[key].current.value;
                return v !== undefined && v !== '' && c;
            }, true);
        };
        _this.pushState = function () {
            var notifyChange = function () {
                var date = _this.buildDate(_this.getFields().reduce(function (c, fields) {
                    return "".concat(c).concat(_this.getFieldPrefix(fields)).concat(_this.inputRef[fields].current.value);
                }, ''));
                _this.props.onChange && _this.props.onChange(date.format(_this.getFormat()), date);
            };
            _this.state.completedOneTime ? notifyChange() : _this.setState({ completedOneTime: true }, notifyChange);
        };
        _this.sortField = function (a, b) {
            return _this.getFieldConfig(a).order - _this.getFieldConfig(b).order;
        };
        _this.changeInputRef = function (selectDate) {
            var fieldsUsed = _this.getFields().sort(_this.sortField);
            fieldsUsed.forEach(function (fieldName) {
                return (0, function_1.pipe)(O.fromNullable(_this.inputRef[fieldName].current), O.chain(function (c) {
                    if (selectDate && fieldName !== 'hours') {
                        c.value = selectDate.format(_this.getFieldConfig(fieldName).format);
                    }
                    return O.some(c);
                }), O.map(function (c) { return c.focus(); }));
            });
            _this.onFocusChange$.next(true);
        };
        _this.changeDate = function (value) {
            return (0, function_1.pipe)(O.fromNullable(value), O.map(function (v) { return (0, moment_timezone_1.default)(v, (0, dateRawFormatter_1.getFormat)(_this.props.dateType)); }));
        };
        _this.calendar = function () {
            return ((0, jsx_runtime_1.jsx)(Picker_1.DatePicker, { selectionType: {
                    pickerType: 'day',
                    lowerBound: _this.props.calendarDateLimits && _this.props.calendarDateLimits.lowerBound,
                    upperBound: _this.props.calendarDateLimits && _this.props.calendarDateLimits.upperBound,
                    startDate: _this.changeDate(_this.props.value),
                    multipleSelect: false,
                    onChange: _this.changeInputRef,
                }, theme: {
                    disabled: false,
                    label: '',
                    contentTheme: 'popover-sm',
                    pickerType: 'icon',
                    pickerTheme: 'borderless',
                }, appendClickListenerToElementRef: _this.props.appendClickListenerToElementRef }));
        };
        _this.state = {
            completedOneTime: false,
        };
        return _this;
    }
    DateTimeField.prototype.componentDidMount = function () {
        var _this = this;
        this.subscription = this.onFocusChange$
            .pipe((0, operators_1.filter)(function () { return _this.allFieldIsFilled() || _this.state.completedOneTime; }))
            .subscribe(this.pushState.bind(this));
    };
    DateTimeField.prototype.componentWillUnmount = function () {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    };
    DateTimeField.prototype.getFields = function (filterT) {
        var _this = this;
        var dateField = ['year', 'month', 'day'];
        var timeField = ['hours', 'mins'];
        var fields = function () {
            switch (_this.props.dateType) {
                case 'date':
                    return dateField;
                case 'dateHour':
                    return dateField.concat(['hours']);
                case 'dateTime':
                    return dateField.concat(timeField);
                case 'time':
                    return timeField;
                case 'monthYear':
                    return ['year', 'month'];
            }
        };
        if (!filterT) {
            return fields();
        }
        var c = fields().filter(function (f) {
            if (filterT === 'timeField') {
                return timeField.indexOf(f) !== -1;
            }
            return dateField.indexOf(f) !== -1;
        });
        return c;
    };
    DateTimeField.prototype.getFieldPrefix = function (field) {
        switch (field) {
            case 'year':
                return '';
            case 'month':
                return '-';
            case 'day':
                return '-';
            case 'hours':
                return this.hasDate() ? ' ' : '';
            case 'mins':
                return ':';
        }
    };
    DateTimeField.prototype.getFieldConfig = function (field) {
        switch (field) {
            case 'year':
                return {
                    placeholder: 'Anno',
                    format: 'YYYY',
                    length: 4,
                    divider: '/',
                    order: 3,
                    debounceTime: 450,
                };
            case 'month':
                return {
                    placeholder: 'Mese',
                    format: 'M',
                    length: 2,
                    divider: this.props.dateType === 'monthYear' ? undefined : '/',
                    order: 2,
                    debounceTime: 100,
                };
            case 'day':
                return {
                    placeholder: 'Giorno',
                    format: 'D',
                    length: 2,
                    divider: undefined,
                    order: 1,
                    debounceTime: 100,
                };
            case 'hours':
                return {
                    placeholder: 'Ore',
                    format: 'H',
                    length: 2,
                    divider: undefined,
                    order: 4,
                    debounceTime: 100,
                };
            case 'mins':
                return {
                    placeholder: 'Minuti',
                    format: 'm',
                    length: 2,
                    divider: ':',
                    order: 5,
                    debounceTime: 100,
                };
        }
    };
    DateTimeField.prototype.getFormat = function () {
        return (0, dateRawFormatter_1.getFormat)(this.props.dateType);
    };
    DateTimeField.prototype.hasDate = function () {
        switch (this.props.dateType) {
            case 'date':
                return true;
            case 'dateHour':
                return true;
            case 'dateTime':
                return true;
            case 'monthYear':
                return true;
            case 'time':
                return false;
        }
    };
    DateTimeField.prototype.hasTime = function () {
        switch (this.props.dateType) {
            case 'date':
                return false;
            case 'dateHour':
                return true;
            case 'dateTime':
                return true;
            case 'monthYear':
                return false;
            case 'time':
                return true;
        }
    };
    DateTimeField.prototype.buildDate = function (date, format) {
        return (0, moment_timezone_1.default)(date, format || this.getFormat(), true);
    };
    DateTimeField.prototype.formatDateTime = function (format, input) {
        var date = this.buildDate(this.props.value || '');
        if (!date.isValid()) {
            return input.current ? input.current.value : '';
        }
        return date.format(format);
    };
    DateTimeField.prototype.componentDidUpdate = function (prevProps) {
        var _this = this;
        if (this.props.value !== prevProps.value && typeof this.props.value === 'undefined') {
            Object.keys(this.inputRef).map(function (f) {
                if (_this.inputRef[f].current) {
                    _this.inputRef[f].current.value = '';
                }
            });
        }
    };
    DateTimeField.prototype.renderField = function (field) {
        var config = this.getFieldConfig(field);
        return ((0, jsx_runtime_1.jsxs)(React.Fragment, { children: [config.divider ? (0, jsx_runtime_1.jsx)("span", __assign({ className: "divider" }, { children: config.divider })) : null, (0, jsx_runtime_1.jsx)(input_1.Input, { name: (0, nameFieldsBuilder_1.buildFieldName)(this.props.name, field), className: field, placeholder: config.placeholder, type: "digits", value: this.formatDateTime(config.format, this.inputRef[field]), forwardedRef: this.inputRef[field], maxLength: config.length, onChange: this.pushUpDateTime(field, config.length), disabled: this.props.disabled, debounceTime: config.debounceTime, autoComplete: "off" })] }, field));
    };
    DateTimeField.prototype.render = function () {
        var _this = this;
        return ((0, jsx_runtime_1.jsx)("div", __assign({ className: (0, clsx_1.default)('date-time', this.props.className, this.props.appendCalendar ? 'calendar' : undefined) }, { children: (0, jsx_runtime_1.jsxs)(FlexView_1.FlexView, __assign({ gutters: this.props.appendCalendar
                    ? { tb: { xs: 'xs', md: 'none' }, l: 'sm' }
                    : { tb: { xs: 'xs', md: 'none' }, lr: 'sm' }, hAlignContent: "left" }, { children: [this.hasDate() && ((0, jsx_runtime_1.jsx)(FlexView_1.FlexView.Item, __assign({ grow: false }, { children: this.getFields('dateField')
                            .sort(this.sortField)
                            .map(function (f) { return _this.renderField(f); }) }))), this.props.appendCalendar && (0, jsx_runtime_1.jsx)(FlexView_1.FlexView.Item, __assign({ grow: false }, { children: this.calendar() })), this.hasTime() && ((0, jsx_runtime_1.jsx)(FlexView_1.FlexView.Item, __assign({ grow: true }, { children: this.getFields('timeField')
                            .sort(this.sortField)
                            .map(function (f) { return _this.renderField(f); }) })))] })) })));
    };
    return DateTimeField;
}(React.PureComponent));
exports.DateTimeField = DateTimeField;
exports.DateTime = (0, fieldMaker_1.makeField)(DateTimeField);
//# sourceMappingURL=DateTime.js.map